<div class="workingOut">
    <div class="blockColor">
        <div class="arrow">
            <a href="/" class="arrow-link">
                <span class="arrow-icon">&#8594;</span>
            </a>
        </div>
    </div>
    <div class="photoBlock">
        <img src="photo/IMG_workingOut_1.jpg" class="photo" alt="фото_1" />
    </div>
    <div class="textBlock">
        <p class="text1">Данный раздел находится в стадии разработки</p>
    </div>
    <div class="textBlock">
        <p class="text2">Раздел скоро будет доступен</p>
    </div>
</div>

<style>
    .workingOut {
        width: 100%;
        height: 100%;
    }

    .blockColor {
        width: 100%;
        height: 60px;
        background-color: #4f7942;
        margin-bottom: 30px;
    }
    .arrow {
        margin: 0 auto;
        height: 60px;
        display: flex; /* Добавляем flexbox */
        flex-direction: column; /* Выравниваем по вертикали */
        justify-content: center;
    }
    .arrow-link {
        display: inline-block;
        position: relative;
        color: #eaf4e5;
        text-decoration: none;
    }
    .arrow-icon {
        position: absolute;
        font-size: 24px;
        transform: translateY(-50%) rotate(180deg);
    }

    .photoBlock {
        max-width: 50%;
        margin: 0 auto;
        margin-top: 40vh;
        margin-bottom: 40px;
    }

    .photo {
        width: 100px;
        height: 100px;
        display: block;
        margin: 0 auto;
        animation: rotate 5s linear infinite; /* Adjust duration as needed */
    }

    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .textBlock {
        margin: 0 auto;
    }

    .text1,
    .text2 {
        margin: 0;
        color: #4f7942;
        text-align: center;
    }

    .text1 {
        font-size: 25px;
        font-weight: 600;
    }

    .text2 {
        font-size: 17px;
        font-weight: 200;
    }

    @media (min-width: 481px) {
        .arrow {
            max-width: 50%;
        }
        .textBlock {
            max-width: 50%;
        }
        .photoBlock {
            margin-top: 40vh;
        }
    }
    @media (max-width: 480px) {
        .arrow {
            max-width: 90%;
        }
        .textBlock {
            max-width: 90%;
        }
        .photoBlock {
            margin-top: 50%;
        }
    }
</style>
